import { toDecimals } from "./decimalConverter"

export const toPercentage = (value: number, total: number): number => {
  const percentage = (value / total) * 100
  return toDecimals(percentage, 0)
}
